import * as React from 'react';
import Box from '@mui/material/Box';
import InputBase from '@mui/material/InputBase';
import SearchIcon from '@mui/icons-material/Search';
import { tr } from "../../i18n";

export default function PrimarySearchBar({ value, onChange, placeholder = tr("Search...") }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: '#F3F4F6',
        borderRadius: '10px',
        px: 1.5,
        height: '42px',
        width: '100%',
        transition: 'all 0.2s ease',
        border: '1.5px solid transparent',
        '&:focus-within': {
          backgroundColor: '#fff',
          borderColor: '#008080',
          boxShadow: '0 0 0 3px rgba(0, 128, 128, 0.08)',
        },
      }}
    >
      <SearchIcon
        sx={{
          color: '#9CA3AF',
          fontSize: 20,
          mr: 1,
          flexShrink: 0,
        }}
      />
      <InputBase
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        inputProps={{ 'aria-label': 'search' }}
        sx={{
          flex: 1,
          fontFamily: "'Electrolize', sans-serif",
          fontSize: '14px',
          color: '#111827',
          '& ::placeholder': {
            color: '#9CA3AF',
            opacity: 1,
          },
        }}
      />
    </Box>
  );
}
